// Defina o formato de moeda conforme a configuração da sua loja.
// Exemplo: "R${{amount}}" para Real ou "${{amount}}" para dólar.
var moneyFormat = window.moneyFormat || "R${{amount}}";

// Função para formatar valores em centavos conforme o moneyFormat.
function formatMoney(cents) {
  var value = (cents / 100).toFixed(2);
  return moneyFormat.replace('{{amount}}', value);
}

const defaults = { 
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerCloseButton: '.js-ajax-cart-drawer-close-button', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartDrawerTriggerMob: '.js-ajax-cart-drawer-triggers', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', // classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', // classname,
  checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerCloseButton = document.querySelector(defaults.cartDrawerCloseButton);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartDrawerTriggerMob = document.querySelector(defaults.cartDrawerTriggerMob);

const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelectorAll(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

const ctmFormBtn = document.querySelector('.upsell-popup');

// Adiciona os eventos do add-to-cart
document.addEventListener("DOMContentLoaded", function() {
    for (let i = 0; i < addToCart.length; i++) {
        addToCart[i].addEventListener('click', function(event) {
            event.preventDefault();
            const formID = this.closest('form').getAttribute('id');
            addProductToCart(formID);
        });
    }
});

function addProductToCart(formID) {
    var form = document.getElementById(formID);
    var btn = form ? form.querySelector(defaults.addToCart + ', [type="submit"]') : null;
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('faetton-adding'); btn.setAttribute('aria-busy','true'); btn.innerHTML = 'Adicionando...'; }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID).serialize(),
        success: addToCartOk,
        complete: function(){ if(btn){ btn.classList.remove('faetton-adding'); btn.removeAttribute('aria-busy'); btn.innerHTML = original || 'Adicionar ao carrinho'; } },
        error: function(){ if(btn){ btn.classList.add('faetton-add-error'); setTimeout(function(){ btn.classList.remove('faetton-add-error'); }, 1200); } }
    });
}

if(ctmFormBtn) {
    const upsellBtn = document.querySelector('button.upsell_btn');
    const upsOverlay = document.querySelector('.upsell-overlay');
    const btnClsModal = document.querySelectorAll('.cls-modal');
    function addProductToCart(frmId) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('#' + frmId).serialize(),
            success: addToCartOk,
        });
    }
    upsellBtn.addEventListener('click', function(event) {
        event.preventDefault();
        const frmId = this.closest('form').getAttribute('id');
        const getFormId = document.querySelector('.upsell-popup').getAttribute('data-form');
        setTimeout(function() {
            addProductToCart(frmId);
            document.querySelector('.upsell-popup').classList.add('hidden');
            document.querySelector('.upsell-overlay').classList.add('hidden');
        },500);
        addProductToCart(getFormId);
    });
    upsOverlay.addEventListener('click', function() {
        const getFormId = document.querySelector('.upsell-popup').getAttribute('data-form');
        addProductToCart(getFormId);
    });
    for(let btn of btnClsModal) {
        btn.addEventListener('click', function() {
            const getFormId = document.querySelector('.upsell-popup').getAttribute('data-form');
            addProductToCart(getFormId);
        });
    }
}

function addUpsellToCart(variant_id) {
  const data = {
    "id": variant_id,
    "quantity": 1
  };
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: data,
    success: addToCartOk,

  });
}

function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);

            if (cart.item_count === 0) {
               $('#upCart').hide();
                localStorage.removeItem('shipping_protection');
                renderCart(cart);
                cartDrawerContent.innerHTML = 'Carrinho vazio';
            } else {
                $('#upCart').show();
                renderCart(cart);
            }
        },
    });
}

// --- INÍCIO: Atualização do cálculo de free shipping ---
const freeShippingNode = document.querySelector('.ajax-cart-drawer__free-shipping');
const free_shipping_from = freeShippingNode ? freeShippingNode.getAttribute('data-free_shipping_from') : 0;
let free_shipping_progress = 0;

function renderCart(cart) {
    const freeShip = document.querySelector('.free-shipping-amount');
    const freeGift = document.querySelector('.free-gift-1');
    const freeBag = document.querySelector('.free-gift-2');
    const progressbar = document.querySelector('#nprogress-bar');

    // Alterado: uso de parseFloat para aceitar valores decimais
    const freeShipAmount = parseFloat(freeShip.getAttribute('data-amount')) * 100;
    const freeGiftAmount = parseFloat(freeGift.getAttribute('data-amount')) * 100;
    const freeBagAmount = parseFloat(freeBag.getAttribute('data-amount')) * 100;
    
    clearCartDrawer();

    if(cart.total_price >= freeBagAmount) {
      freeShip.classList.add('border-change');
      freeGift.classList.add('border-change');
      freeBag.classList.add('border-change');
      progressbar.value = 100;
    } else if(cart.total_price >= freeGiftAmount && cart.total_price < freeBagAmount) {
      freeShip.classList.add('border-change');
      freeGift.classList.add('border-change');
      freeBag.classList.remove('border-change');
      progressbar.value = 67;
    } else if(cart.total_price >= freeShipAmount && cart.total_price < freeGiftAmount) {
      freeShip.classList.add('border-change');
      freeGift.classList.remove('border-change');
      freeBag.classList.remove('border-change');
      progressbar.value = 33;
    } else if (cart.total_price < freeShipAmount) {
      freeShip.classList.remove('border-change');
      freeGift.classList.remove('border-change');
      freeBag.classList.remove('border-change');
      progressbar.value = 0;
    }
  
    // --- Agrupamento dos itens por nome para cupom de quantidade ---
    let groupQuantities = {};
    cart.items.forEach(function(item) {
      let baseTitle = item.product_title || item.title;
      if(!groupQuantities[baseTitle]) {
          groupQuantities[baseTitle] = 0;
      }
      groupQuantities[baseTitle] += item.quantity;
    });
  
    // --- Renderização dos itens ---
    let newCartTotal = 0; // soma dos preços originais (sem cupom)
    let couponTotal = 0;   // soma dos preços efetivos (após cupom de quantidade)
    let itemsHTML = "";
  
    cart.items.forEach(function(item, index) {
      // Usa o preço original para bloquear descontos do back end
      let basePrice = item.original_line_price;
      newCartTotal += basePrice;
  
      // Define o desconto local (cupom) para o grupo com mesmo nome, ignorando a variante
      let couponRate = 0;
      let baseTitle = item.product_title || item.title;
      if(groupQuantities[baseTitle] >= 3) {
          couponRate = 10;
      } else if(groupQuantities[baseTitle] === 2) {
          couponRate = 5;
      }
  
      let effectivePrice = basePrice;
      let priceHTML = "";
      if(couponRate > 0) {
          effectivePrice = Math.round(basePrice * (1 - couponRate / 100));
          priceHTML = '<div class="ajax-cart-item__price" style="text-decoration: line-through;"><span class="money">' + formatMoney(basePrice) + '</span></div>' +
                      '<div class="ajax-cart-item__discounted-price" style="color: #e00b25; position: absolute; right: 0; bottom: 25px; letter-spacing: .5px; font-weight: 400; font-size: 14px; line-height: 30px; white-space: nowrap;"><span class="money">' + formatMoney(effectivePrice) + '</span> <span class="discount-flag" style="background-color: #e00b25; color: #fff; padding: 2px; font-size: 14px;">' + couponRate + '% OFF</span></div>';
      } else {
          priceHTML = '<div class="ajax-cart-item__price"><span class="money">' + formatMoney(basePrice) + '</span></div>';
      }
  
      couponTotal += effectivePrice;
  
      const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
      const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
      const productVariant = '<div class="ajax-cart-item__variant">' + item.options_with_values[0].value + '</div>';
      const productQuantity = '<div class="ajax-cart-item__quantity" data-qty="' + item.quantity + '"><span class="ajax-cart-item__minus">-</span> ' + item.quantity + ' <span class="ajax-cart-item__plus">+</span></div>';
      const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.646 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.646a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg></div>';
      const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + (index + 1) + '" data-ptitle="' + item.title + '">' + productTitle + productImage + productVariant + priceHTML + productQuantity + productRemove + '</div>';
  
      itemsHTML += concatProductInfo;
    });
  
    cartDrawerContent.innerHTML = itemsHTML;
  
    // --- Cálculo dos descontos e do subtotal final ---
    // O desconto do cupom é a diferença entre o total original e a soma dos preços com cupom
    let couponDiscountAmount = newCartTotal - couponTotal;
  
    // Desconto global: agora aplicado sobre o subtotal (couponTotal)
    let globalDiscountRate = 0;
    if(couponTotal >= freeBagAmount) {
      globalDiscountRate = 7;
    } else if(couponTotal >= freeGiftAmount) {
      globalDiscountRate = 3;
    }
    let globalDiscountAmount = Math.round(couponTotal * (globalDiscountRate / 100));
  
    // Subtotal final: o subtotal com cupom menos o desconto global
    let finalTotal = couponTotal - globalDiscountAmount;
  
    // Atualiza o subtotal exibido – utilizando <span class="money"> para que a Shopify trate a moeda
    if(globalDiscountRate > 0) {
      document.querySelector('.ajax-cart-drawer__subtotal__price').innerHTML =
      '<div style="display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap;">' +
          '<div style="text-decoration: line-through;"><span class="money">' + formatMoney(couponTotal) + '</span></div>' +
          '<div style="color: #e00b25;"><span class="money">' + formatMoney(finalTotal) + '</span>' +
             ' <span class="discount-flag" style="background-color: #e00b25; color: #fff; padding: 2px; font-size: 14px;">' + globalDiscountRate + '% OFF</span>' +
          '</div>' +
      '</div>';
    } else {
      document.querySelector('.ajax-cart-drawer__subtotal__price').innerHTML = '<span class="money">' + formatMoney(couponTotal) + '</span>';
    }
  
    // O desconto total exibido é a soma do desconto do cupom e do desconto global
    let totalDiscountDisplayed = couponDiscountAmount + globalDiscountAmount;
    var discountContainer = document.querySelector('.ajax-cart-drawer__discount');
    if(discountContainer) {
      if(totalDiscountDisplayed > 0) {
         discountContainer.style.display = '';
         let discountElem = document.querySelector('.ajax-cart-drawer__discount .ajax-cart-drawer__discount__price');
         if(discountElem) {
             discountElem.innerHTML = '-<span class="money">' + formatMoney(totalDiscountDisplayed) + '</span>';
         }
      } else {
         discountContainer.style.display = 'none';
      }
    }
  
    cartCounter.forEach(counter => {
      counter.innerHTML = cart.item_count;
    });
  
    checkProtectionExist();
  
    document.querySelectorAll('.js-ajax-remove-from-cart').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var line = this.closest('.ajax-cart-item__single').getAttribute('data-line');
        faettonConfirmRemove(function(){ changeItem(line); });
      });
    });
  
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
      window.bucksCC.reConvert(document.querySelector('.js-ajax-cart-drawer'));
    }
  
    document.querySelectorAll('.ajax-cart-item__plus').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var parent = this.closest('.ajax-cart-item__single');
        var line = parent.getAttribute('data-line');
        var qtyElem = parent.querySelector('.ajax-cart-item__quantity');
        var currentQty = parseInt(qtyElem.getAttribute('data-qty'));
        var newQty = currentQty + 1;
        plusItem(line, newQty);
      });
    });
    document.querySelectorAll('.ajax-cart-item__minus').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var parent = this.closest('.ajax-cart-item__single');
        var line = parent.getAttribute('data-line');
        var qtyElem = parent.querySelector('.ajax-cart-item__quantity');
        var currentQty = parseInt(qtyElem.getAttribute('data-qty'));
        if(currentQty > 1) {
          var newQty = currentQty - 1;
          minusItem(line, newQty);
        }
      });
    });
}
  
function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
    document.body.style.overflowY = 'hidden';
}
  
function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    document.body.style.overflowY = '';
    document.body.style.position = '';
}
  
function clearCartDrawer() {
    if (cartDrawerContent) cartDrawerContent.innerHTML = '';
}
  
function openAddModal() {
    if (cartModal) cartModal.classList.add('is-open');
}
  
function closeAddModal() {
    if (cartModal) cartModal.classList.remove('is-open');
}
  
function openCartOverlay() {
    if (!cartOverlay) return;
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}
  
function closeCartOverlay() {
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}
  
function plusItem(line, quantity, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                addToCartOk();
            }
        },
    });
}
  
function minusItem(line, quantity, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}
  

function faettonConfirmRemove(callback) {
    var old = document.querySelector('.faetton-cart-remove-confirm');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'faetton-cart-remove-confirm';
    wrap.innerHTML = '<div class="faetton-cart-remove-confirm__box" role="dialog" aria-modal="true" aria-label="Remover produto"><p>Remover este produto do carrinho?</p><div><button type="button" class="faetton-cart-remove-confirm__cancel">Cancelar</button><button type="button" class="faetton-cart-remove-confirm__ok">Remover</button></div></div>';
    document.body.appendChild(wrap);
    function close(){ wrap.remove(); }
    wrap.addEventListener('click', function(e){ if(e.target === wrap || e.target.closest('.faetton-cart-remove-confirm__cancel')) close(); });
    wrap.querySelector('.faetton-cart-remove-confirm__ok').addEventListener('click', function(){ close(); callback(); });
}

function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}
  
function onCartUpdate(cart) {
    //console.log('items in the cart?', cart.item_count);
}
  
function addToCartOk() {
    openCartDrawer();
    openCartOverlay();
    fetchCart();
    recommendedProductsOpen();
    showSuccessMessage();
}
  
function showSuccessMessage() {
    console.log("Function called");
    var successMessage = document.querySelector('.ajax-cart-drawer__success-message');
    if (successMessage) {
        console.log("Element found", successMessage);
        successMessage.style.display = 'block';
        setTimeout(function () {
            successMessage.style.display = 'none';
        }, 3000);
    } else {
        console.log("Element not found");
    }
}
  
function removeProductFromCart() {
    cartCounter.forEach(function(counter){ counter.innerHTML = Math.max(0, Number(counter.innerHTML || 0) - 1); });
}
  
 
function recommendedProductsOpen() {
    let recPop = document.querySelector('.recommended-popup');
    if (!recPop || recPop.classList.contains('no-cart-upsell')) return;
    recPop.classList.add('is-open');
    document.body.style.overflowY = 'hidden';
}
  
function recommendedProductsClose() {
    let recPop = document.querySelector('.recommended-popup');
    if (recPop) recPop.classList.remove('is-open');
    document.body.style.overflowY = '';
}
  
function checkProtectionExist() {
    var protectionTitleToCheck = "Shipping Protection";
    var protectionTitleToCheck2 = "Proteção de envio";
    var ship_pro_already = localStorage.getItem("shipping_protection");
    var foundLine;
    $('.ajax-cart-item__single').each(function () {
      var currentTitle = $(this).data('ptitle');
      if (currentTitle === protectionTitleToCheck || currentTitle === protectionTitleToCheck2) {
          $(".styles_AddonsModule__toggle__fnpE0").addClass("styles_ToggleSwitch--active__jLEhN");
          $(".styles_ToggleSwitch__JFeYW").addClass("styles_ToggleSwitch--active__jLEhN");
          $(".styles_ToggleSwitch__circle__JNYJJ").addClass("styles_ToggleSwitch__circle--active__ZRSCR");
      } else {
        if(ship_pro_already != 1) {
          localStorage.setItem("shipping_protection", 1);
          $('.upcart-addons-toggle').click();
        }
      }
    });
}
  
if (cartModalClose) cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
});
  
if (cartDrawerClose) cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
    recommendedProductsClose();
});
  
if (cartOverlay) cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
    recommendedProductsClose();
});
  
if (cartDrawerTrigger) cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    fetchCart();
    openCartDrawer();
    openCartOverlay();
    recommendedProductsOpen();
});
  
var upcartToggle = document.querySelector(".upcart-addons-toggle");
if (upcartToggle) upcartToggle.addEventListener("click", function () {
    var toggleElement = document.querySelector(".styles_AddonsModule__toggle__fnpE0");
    var switchElement = document.querySelector(".styles_ToggleSwitch__JFeYW");
    var circleElement = document.querySelector(".styles_ToggleSwitch__circle__JNYJJ");
  
    if (toggleElement.classList.contains("styles_ToggleSwitch--active__jLEhN")) {
        toggleElement.classList.remove("styles_ToggleSwitch--active__jLEhN");
        switchElement.classList.remove("styles_ToggleSwitch--active__jLEhN");
        circleElement.classList.remove("styles_ToggleSwitch__circle--active__ZRSCR");
  
        var vId = parseInt(this.getAttribute('data-product-id'));
        var protectionTitleToCheck = "Shipping Protection";
        var protectiontit = "Proteção de envio";
        var foundLine;
        document.querySelectorAll('.ajax-cart-item__single').forEach(function (element) {
            var currentTitle = element.getAttribute('data-ptitle');
            if (currentTitle === protectionTitleToCheck || currentTitle === protectiontit) {
                foundLine = element.getAttribute('data-line');
                minusItem(foundLine, 0);
            }
        });
    
    } else {
        toggleElement.classList.add("styles_ToggleSwitch--active__jLEhN");
        switchElement.classList.add("styles_ToggleSwitch--active__jLEhN");
        circleElement.classList.add("styles_ToggleSwitch__circle--active__ZRSCR");
  
        var vId = parseInt(this.getAttribute('data-product-id'));
        addUpsellToCart(vId);
    }
});
  
if (cartDrawerTriggerMob) cartDrawerTriggerMob.addEventListener('click', function(event) {
    event.preventDefault();
    fetchCart();
    openCartDrawer();
    openCartOverlay();
    recommendedProductsOpen();
});
  
// FAETTON: cart fetch is lazy. Do not fetch cart on PDP first paint.
// It now fetches only on cart icon click, add-to-cart, quantity change or remove.
